// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iaurwyjoyrfwxejyglmk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhdXJ3eWpveXJmd3hlanlnbG1rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwODU0NDcsImV4cCI6MjA1ODY2MTQ0N30.tcXopsVxT9tjF_eccB2K8t95kozZx71EZOn9BUUYNlU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);